import { gql } from "@apollo/client";

export const setLensCtaData = gql`
    mutation setLensCta($lensId: ID!, $lensCta: MyLensesLensCtaInput) {
        setMyLensesCtaV2(input: { lensId: $lensId, lensCta: $lensCta }) {
            lens {
                id
                lensCta {
                    website {
                        url
                    }
                    deeplink {
                        uri
                        appName
                        iosAppId
                        androidAppUrl
                    }
                    type
                    text
                }
                status
            }
        }
    }
`;
